import cn from 'classnames';
import React, { useCallback } from 'react';

import gearIcon from '@/finsight/ui/components/staticPages/Company/OurSolutions/assets/icons/gear.svg';
import styles from './module.scss';
import { buttonStyles } from '@dealroadshow/uikit/core/components/Button';

interface IProps {
  title: string,
  content: string,
  product: string,
  buttonContent: string,
  icon: string,
  link?: string,
  itemClass?: string,
  headClass: string,
  onLinkClick?: () => void,
}

const Module = ({ link = '#', ...props }: IProps) => {
  const clickHandler = useCallback((event) => {
    if (typeof props.onLinkClick === 'function') {
      event.preventDefault();
      props.onLinkClick();
    }
  },
  [props.onLinkClick]);

  return (
    <div className={ cn(styles.module, props.itemClass) }>
      <span className={ cn(props.headClass, styles.moduleHead) }>
        <img src={ gearIcon } alt={ props.title } />
      </span>
      <div className={ styles.content }>
        <span className={ cn(styles.iconContainer, styles.iconPositioner) }>
          <i
            className={ styles.icon }
            dangerouslySetInnerHTML={ { __html: props.icon } }
          />
        </span>
        <div>
          <h1>{ props.title }</h1>
          <p>{ props.content }</p>
        </div>
        <div className={ styles.footer }>
          <a
            target="_blank"
            data-test={ `${ props.buttonContent } ${ props.title }` }
            href={ link }
            onClick={ clickHandler }
            className={ cn(buttonStyles.btn, buttonStyles.text) }
          >
            { props.buttonContent }
          </a>
          <p>{ props.product }</p>
        </div>
      </div>
    </div>
  );
};

export default Module;
